<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
const BASE_API = require('./components/service/prod.env')

  import axios from 'axios';
export default {
  name: 'App',
  created() {
    window.addEventListener('beforeunload', this.removeUser)
    this.testFunction()
  },
  methods: {
    removeUser() {
      if (window.performance) {
        console.log("window.performance works fine on this browser");
      }
      if (window.performance.navigation.type != 1) {
        localStorage.removeItem('user')
        localStorage.removeItem('selectedVessel')
      }
    },
      testFunction() {
    
      setInterval(function () {
        
        axios.post(BASE_API.NODE_ENV+"/form/requisition", {},{
                headers: {'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user'))}

                }).then(res => {
                    console.log("jwt time interval",res.data.jwt)
                    localStorage.setItem('user', JSON.stringify(res.data.jwt)); 
                });
    }, 1500000);
      
   }
  },
  data: () => ({
    //
  }),
};
</script>



// WEBPACK FOOTER //
// src/App.vue